import { render, staticRenderFns } from "./ReshippingIndex.vue?vue&type=template&id=38e53a39&scoped=true&"
import script from "./ReshippingIndex.vue?vue&type=script&lang=js&"
export * from "./ReshippingIndex.vue?vue&type=script&lang=js&"
import style0 from "./ReshippingIndex.vue?vue&type=style&index=0&id=38e53a39&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e53a39",
  null
  
)

export default component.exports